/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";

import globalReducer from "containers/Shared/App/reducer";
import languageProviderReducer from "containers/Shared/LanguageProvider/reducer";

/**
 * Merges the main reducer with dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    global: globalReducer,
    language: languageProviderReducer,
    ...injectedReducers,
  });
}
